<script lang="ts" setup>
const route = useRoute();
const url = computed(() => import.meta.env.VITE_DOMAIN + route.fullPath);
const props = defineProps({
  border: {
    type: Boolean,
    default: true
  },
  color: {
    type: String,
    default: 'color-gray-3'
  },
  round: {
    type: Boolean,
    default: false
  }
});

function copySelectedText() {
  const selectedText = url.value;
  if (selectedText) {
    navigator.clipboard
      .writeText(selectedText)
      .then(() => {
        //console.log('Text copied to clipboard');
      })
      .catch(err => {
        console.error('Failed to copy text: ', err);
      });
  }
}
</script>

<template>
  <div class="share" :class="[{ border: border, round: round }, color]">
    <div class="share__item">
      <a :href="`https://www.facebook.com/sharer.php?u=${url}`"><svg-icon name="icon-fb" /></a>
    </div>
    <div class="share__item">
      <a :href="`http://line.naver.jp/R/msg/text/?${url}`"><svg-icon name="icon-line" /></a>
    </div>
    <div class="share__item">
      <svg-icon name="icon-copy" @click="copySelectedText" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.share {
  display: inline-flex;
  cursor: pointer;

  &.border {
    border: 1px solid $color-gray-line;
    border-left: none;
    border-bottom: none;

    .share {
      &__item {
        border: 1px solid $color-gray-line;
        border-top: none;
        border-right: none;
      }
    }
  }

  &.round {
    gap: toRem(8);

    .share {
      &__item {
        border: 1px solid $color-gray-line;
        border-radius: toRem(100);
      }
    }
  }

  &.color-gray-1 {
    .share {
      &__item {
        svg {
          color: $color-gray-1;
        }
      }
    }
  }

  &.color-gray-3 {
    .share {
      &__item {
        svg {
          color: $color-gray-3;
        }
      }
    }
  }

  &.blue3 {
    .share {
      &__item {
        border-color: $bg-2;

        svg {
          color: $blue3;
        }
      }
    }
  }

  &__item {
    display: flex;
    align-items: center;
    justify-content: center;
    width: toRem(30);
    height: toRem(30);

    svg {
      width: toRem(20);
      height: toRem(20);
    }
  }
}
</style>
